/**
 * @Author: WeiZisen
 * @Date: 2021-03-15 11:13:04
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-15 11:19:13
 * @Description: 请输入一段描述
 * @FilePath: \Vue_RebarProcess\src\store\index.js
 */
/**
 * @description 导入所有 vuex 模块，自动加入namespaced:true，用于解决vuex命名冲突，请勿修改。
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const files = require.context('./modules', false, /\.js$/)
const modules = {}
files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
Object.keys(modules).forEach((key) => {
  modules[key]['namespaced'] = true
})
let name = 'wzs'
const store = new Vuex.Store({
  modules,
})
export default store
